/**
 * 건설사별 constructionPage 설정 (아이콘, 색상, 문구)
 * 라우트 name과 동일한 키 사용
 */
export default {
	seohan: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/seohan/shOn.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `서한이 제공하는<br />
    <span style="color:#fff">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#1d90cf",
		colorText: "#fff",
	},
	namhae: {
		imagePlay: require("@/assets/namhae/play_color.svg"),
		imageMark: require("@/assets/namhae/btn_color.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `남해종합건설이<br/>제공하는<br />
    <span style="color:#0d2d84">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#fff",
		colorText: "#000",
	},
	dongwon: {
		imagePlay: require("@/assets/dongwon/play_color.svg"),
		imageMark: require("@/assets/dongwon/btn_color.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `동원개발이<br/>제공하는<br />
    <span style="color:#7a0939">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#fff",
		colorText: "#000",
	},
	jpdc: {
		imagePlay: require("@/assets/jpdc/play_color.svg"),
		imageMark: require("@/assets/jpdc/btn_color.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `제주특별자치도<br/>개발공사가 제공하는<br/>
    <span style="color:#362d2b">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#fff",
		colorText: "#000",
	},
	ssgenc: {
		imagePlay: require("@/assets/ssgenc/play_color.svg"),
		imageMark: require("@/assets/ssgenc/btn_color.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `신세계건설이<br/>제공하는<br/>
    <span style="color:#cc0011">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#fff",
		colorText: "#000",
	},
	moa: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/moa/btn.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `<div style="color:#fff">모아주택산업이<br/>제공하는<br />
    <span style="color:#fff">특별한 경험</span>을<br />
    시작해 보세요.</div>`,
		colorMain: "#00046c",
		colorText: "#fff",
		colorTextTitle: "#fff",
	},
	seohee: {
		imagePlay: require("@/assets/seohee/play_color.svg"),
		imageMark: require("@/assets/seohee/btn_color.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `서희건설이 제공하는<br />
    <span style="color:#005092">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#fff",
		colorText: "#000",
	},
	krcon: {
		imagePlay: require("@/assets/krcon/play_color.svg"),
		imageMark: require("@/assets/krcon/btn_color.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `계룡건설이 제공하는<br />
    <span style="color:#126ab4">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#fff",
		colorText: "#000",
	},
	chinhung: {
		imagePlay: require("@/assets/chinhung/play_color.svg"),
		imageMark: require("@/assets/chinhung/onColor.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `진흥기업이 제공하는<br />
    <span style="color:#254aa5">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#fff",
		colorText: "#000",
	},
	hyosung: {
		imagePlay: require("@/assets/hyosung/play_color.svg"),
		imageMark: require("@/assets/hyosung/onColor.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `효성중공업이<br/>제공하는<br />
    <span style="color:#270089">특별한 경험</span>을<br />
    시작해 보세요.`,
		colorMain: "#fff",
		colorText: "#000",
	},
	namkwang: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/namkwang/on.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `<div style="color:#fff">남광토건이 제공하는<br />
    <span style="color:#fff">특별한 경험</span>을<br />
    시작해 보세요.</div>`,
		colorMain: "#115368",
		colorText: "#fff",
		colorTextTitle: "#fff",
	},
	// 새로 추가된 7개
	hjsc: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/hjsc/hjsc.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `HJ중공업이<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#1d8649",
		colorText: "#fff",
		colorTextTitle: "#000",
		colorTextContent: "#000",
		colorTextFooter: "#ddd",
	},
	dongbu: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/dongbu/dongbu.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `동부건설이<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#009d85",
		colorText: "#fff",
		colorTextTitle: "#000",
		colorTextContent: "#000",
		colorTextFooter: "#ddd",
	},
	woobang: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/woobang/woobang.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `SM우방이<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#df0615",
		colorText: "#fff",
		colorTextTitle: "#000",
		colorTextContent: "#000",
		colorTextFooter: "#ddd",
	},
	seokmi: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/seokmi/seokmi.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `석미건설이<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#31006f",
		colorText: "#fff",
		colorTextTitle: "#fff",
		colorTextContent: "#fff",
		colorTextFooter: "#ddd",
	},
	sgcenc: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/sgcenc/sgcenc.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `에스지씨이앤씨가<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#e60012",
		colorText: "#fff",
		colorTextTitle: "#000",
		colorTextContent: "#000",
		colorTextFooter: "#ddd",
	},
	daesung: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/daesung/daesung.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `대성건설이<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#3d475a",
		colorText: "#fff",
		colorTextTitle: "#fff",
		colorTextContent: "#fff",
		colorTextFooter: "#ddd",
	},
	hanshinc: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/hanshinc/hanshinc.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `한신공영이<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#6db328",
		colorText: "#fff",
		colorTextTitle: "#000",
		colorTextContent: "#000",
		colorTextFooter: "#ddd",
	},
	dbcons: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/daebang/daebang.png"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `대방건설이<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#0f1f3c",
		colorText: "#fff",
		colorTextTitle: "#fff",
		colorTextContent: "#fff",
		colorTextFooter: "#ddd",
	},
	daebang: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/daebang/daebang.png"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `대방건설이<br/>제공하는<br /><span style="color:#fff">특별한 경험</span>을<br />시작해 보세요.`,
		colorMain: "#0f1f3c",
		colorText: "#fff",
		colorTextTitle: "#fff",
		colorTextContent: "#fff",
		colorTextFooter: "#ddd",
	},
	hug: {
		imagePlay: require("@/assets/hoban/play2.svg"),
		imageMark: require("@/assets/hug/btn.svg"),
		imageBackground: require("@/assets/hoban/chaedle_pc.png"),
		textTitle: `주택도시보증공사가<br/>제공하는<br />특별한 경험을<br />시작해 보세요.`,
		colorMain: "#036eb7",
		colorText: "#fff",
		colorTextTitle: "#fff",
		colorTextContent: "#fff",
		colorTextFooter: "#ddd",
	},
};
